export default __webpack_public_path__ + "static/rf-kiln-27b89d0f4cd16774f4992ca44945194c.webm";